import React, { useState, useEffect } from 'react';
import './ResultCard.css';
import PropTypes from 'prop-types';
import TrophyIcon from '../../assets/icons/trophy_icon.svg';
import SvgIcon from '../common/SvgIcon.js';
import ExitIcon3 from '../../assets/icons/close_icon4.svg';

function ResultCard ({ resume = {}, jobDescriptionKeywords = [], 
    onClick = () => {}, 
    onRemoveKeyword = () => {},
    isWinner = () => {},
    editedFilenameInputs = {}, 
    fileIndex
  }) 
{
  const displayName = editedFilenameInputs[fileIndex]
    ? `${editedFilenameInputs[fileIndex]}.${resume.filename.split('.').pop()}`
    : resume.filename;

  useEffect(() => {}, [resume.filename, editedFilenameInputs, fileIndex, displayName]);

  const [showMore, setShowMore] = useState(false);

  const sortedKeywords = [...(jobDescriptionKeywords || [])].sort((a, b) =>
    a.localeCompare(b)
  );

  const displayedKeywords = showMore ? sortedKeywords : sortedKeywords.slice(0, 15);

  const isKeywordMatched = (keyword) => {
    return (resume.matching_keywords || []).includes(keyword);
  };

  const handleKeywordClick = (e, keyword) => {
    e.stopPropagation();
    const isMatched = isKeywordMatched(keyword);
    if (isMatched) {
      onClick();
    } else {
      onRemoveKeyword(keyword);
    }
  };

  return (
    <div className={`result-card ${isWinner ? 'winner-card' : ''}`} onClick={() => onClick()}>
      <div className='filename-display'>
        {editedFilenameInputs[fileIndex] ? editedFilenameInputs[fileIndex] : resume.filename}
      </div>

      <div className='card-header'>
        {isWinner && <img src={TrophyIcon} alt='Winning resume' className='trophy-icon'/>}
        <div className='resume-header-content'>
          <h3>{resume.label || 'Untitled Resume'}</h3>
        </div>
        <span className='score-label'>{((resume.similarity_score || 0) * 100).toFixed(1)}%</span>
      </div>

      <div className='progress-bar-container'>
        <div className='progress-bar' style={{ width: `${(resume.similarity_score || 0) * 100}%` }} />
      </div>

      <div className='keywords-container'>
        {displayedKeywords.map((keyword, idx) => {
          const isMatched = isKeywordMatched(keyword);
          return (
            <div 
              key={`${keyword}-${idx}`} 
              className='keyword-tag-container'
              onClick={(e) => handleKeywordClick(e, keyword)}
            >
              <span className={`keyword-tag ${isMatched ? 'matched' : 'unmatched'}`}>
                {keyword}
              </span>
              {!isMatched && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemoveKeyword(keyword);
                  }}
                  className='keyword-remove-button'
                >
                  <SvgIcon
                    src={ExitIcon3}
                    color='#ddd'
                    hoverColor='#6e41c1'
                    size='18px'
                    className='exit-icon list'
                  />
                </button>
              )}
            </div>
          );
        })}
      </div>

      {sortedKeywords.length > 15 && (
        <div className='show-more-container'
          onClick={(e) => {
            e.stopPropagation();
            setShowMore(prev => !prev);
          }}>
          {!showMore ? (
            <button className='show-more-button-card' onClick={(e) => { e.stopPropagation(); setShowMore(true); }}>Show More</button>
          ) : (
            <button className='show-less-button-card' onClick={(e) => { e.stopPropagation(); setShowMore(false); }}>Show Less</button>
          )}
        </div>
      )}
      {resume.preview_image && (
        <div className='preview-image'>
          <img src={`data:image/png;base64,${resume.preview_image}`} alt='Resume preview' />
        </div>
      )}
    </div>
  );
}

ResultCard.propTypes = {
  resume: PropTypes.shape({
    label: PropTypes.string,
    similarity_score: PropTypes.number,
    matching_keywords: PropTypes.array,
    preview_image: PropTypes.string,
    content: PropTypes.string,
    editedFilenameInputs: PropTypes.object,
    fileIndex: PropTypes.number,
    filename: PropTypes.string,
    file_content: PropTypes.string,
    type: PropTypes.string,
    originalIndex: PropTypes.number,
  }),
  jobDescriptionKeywords: PropTypes.array,
  onClick: PropTypes.func,
  onRemoveKeyword: PropTypes.func,
};

ResultCard.defaultProps = {
  resume: PropTypes.shape({
    label: 'Untitled Resume',
    similarity_score: 0,
    matching_keywords: [],
    jobDescriptionKeywords: [],
    content: '',
    editedFilenameInputs: {},
    fileIndex: null,
    filename: '',
    file_content: '',
    type: PropTypes.oneOf([
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'text/plain',
      '',
    ]),
    originalIndex: null,
  }),
  jobDescriptionKeywords: [],
  onClick: () => {},
  onRemoveKeyword: () => {},
};

export default ResultCard;


